module.exports = __webpack_public_path__ + "img/gis2.c19c2f5f.png";